<script setup>
  import { onMounted } from 'vue';
  function isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera
    return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
  }
  onMounted(()=>{
    console.log(process.env.VITE_APP_API_H5_URL, 'process.env.VITE_APP_API_H5_URL')
    if (isMobile())
      window.location.href = process.env.VITE_APP_API_H5_URL
    console.log(isMobile(), 'isMobile===========')
  })
</script>

<template>
  <router-view/>
</template>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #F9FAF9;
  /* width: 100%; */
  min-width: 1200px;
  /* max-width: 1477px; */
  margin: 0 auto;

  overflow: hidden;
  position: relative;
}
img{
  margin: 0;
}
</style>
